import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MatMenuTrigger } from "@angular/material/menu";
import { BtnStyleTypes } from "libraries/ui_button/btn.component";
import { IQuotationVatConfiguration } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { FormGroup } from "@angular/forms";
import { markAllTouched } from "libraries/service/form/mark-touched.util";
import { VatConfigurationFormComponent } from "libraries/component/vat-configuration-form/vat-configuration-form.component";

@Component({
    selector: 'th-total-with-vat-configuration',
    template: `
        <ng-template #template>
            <th-text [strong]="true"
                     [isSticky]="true"
                     [colIndex]="colIndex"
                     [(isCollapsed)]="isCollapsed"
                     [collapser]="!isReadOnly"
                     [canEmitRightPosition]="true"
                     [leftPosition]="leftPosition"
                     (onEmitRightPosition)="emitRightPosition($event)"
                     (onCollapse)="openMenu($event)">
                <strong class="title">{{title}}</strong>
                <ng-container *ngTemplateOutlet="popinContent"></ng-container>
            </th-text>
        </ng-template>
        <ng-template #popinContent>
            <ng-container *ngIf="!isReadOnly">
                <div class="trigger" [matMenuTriggerFor]="menu"></div>
                <mat-menu #menu (close)="changeCellArrow()">
                    <div class="menu-part" (click)="stopClick($event)" (keydown)="keydown($event)">
                        <form [formGroup]="myFormGroup" (ngSubmit)="submitForm()">
                            <vat-configuration-form #vatConfigurationForm
                                                    [myFormGroup]="myFormGroup"
                                                    [menuLayout]="true"
                                                    [vatConfiguration]="vatConfiguration">
                            </vat-configuration-form>
                            <br />
                            <div class="btn-container">
                                <btn label="Valider"
                                     btnType="submit"
                                     [type]="btnType.actionLink">
                                </btn>
                            </div>
                        </form>
                    </div>
                </mat-menu>
            </ng-container>
        </ng-template>
    `,
    styles: [`
        :host {
            display: none
        }

        .title {
            text-transform: uppercase;
        }

        .menu-part {
            margin: 0 .75rem;
            width: 15rem;
        }

        .menu-part .btn-container {
            text-align: right;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThTotalWithVatConfigurationComponent implements OnInit {

    @Input()
    public title: string;
    @Input()
    public colIndex?: number;
    @Input()
    public vatConfiguration: IQuotationVatConfiguration;
    @Input()
    public isReadOnly: boolean;
    @Input()
    public leftPosition: number;

    @Output()
    public readonly onRightPositionChange: EventEmitter<number> = new EventEmitter<number>();
    @Output()
    public readonly onChangeQuotationVatConfiguration: EventEmitter<IQuotationVatConfiguration> = new EventEmitter<IQuotationVatConfiguration>();

    public readonly btnType: typeof BtnStyleTypes = BtnStyleTypes;
    public readonly myFormGroup: FormGroup = new FormGroup({});

    public isCollapsed: boolean = false;
    public canEmitRightPosition: boolean;

    @ViewChild('template', { read: TemplateRef, static: true })
    private readonly template: TemplateRef<{}>;
    @ViewChild(MatMenuTrigger)
    private readonly menu: MatMenuTrigger;
    @ViewChild('vatConfigurationForm')
    private readonly vatConfigurationForm: VatConfigurationFormComponent;

    constructor(
        private readonly viewContainerRef: ViewContainerRef,
    ) {
    }

    public ngOnInit(): void {
        this.myFormGroup.enable();
        this.viewContainerRef.createEmbeddedView(this.template);
    }

    public emitRightPosition(position: number): void {
        if (this.canEmitRightPosition) {
            this.onRightPositionChange.emit(position);
        }
    }

    public openMenu(event: boolean): void {
        if (event) {
            setTimeout(() => {
                this.menu.openMenu();
            });
        }
    }

    public changeCellArrow(): void {
        this.isCollapsed = false;
    }

    public stopClick(event: Event): void {
        event.stopPropagation();
    }

    public keydown(event: KeyboardEvent): void {
        switch (event.key) {
            case ("Tab"):
                event.stopPropagation();
                break;
            default:
                break;
        }
    }

    public submitForm(): void {
        markAllTouched(this.myFormGroup);
        if (this.myFormGroup.invalid) {
            return;
        }
        if (this.vatConfigurationForm) {
            this.onChangeQuotationVatConfiguration.emit(this.vatConfigurationForm.getUpdatedVatConfiguration());
        }

        this.menu.closeMenu();
    }
}
